import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Map } from 'views/common/components';
import StyledBox from 'views/rebranded-module/location-module/LocationsViewV2/components/LocationsMapWrapperV2/LocationsMapWrapperV2.styles';
import { FloatingLocationInfoV2 } from 'views/rebranded-module/common/components';

const LocationsMapWrapperV2 = (props) => {
  const {
    mapInfo,
    setMapInfo,
    mapCenter,
    setMapCenter,
    handleBookNowClick,
    content,
    className,
  } = props;

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  const handleMarkerClick = (id) => {
    setMapInfo((prev) => {
      const index = mapInfo.findIndex((item) => item.id === +id);
      const newMapInfo = [...prev];

      if (index != -1) {
        setMapCenter((prevCenter) => {
          if (isLargeScreen) {
            return {
              ...prevCenter,
              large_screen: {
                lat: Number(prev[index].latitude),
                lng: Number(prev[index].longitude),
                zoom: prevCenter.large_screen.zoom,
              },
            };
          }
          return {
            ...prevCenter,
            small_screen: {
              lat: Number(prev[index].latitude),
              lng: Number(prev[index].longitude),
              zoom: prevCenter.small_screen.zoom,
            },
          };
        });
        newMapInfo[index].show = !prev[index].show;
      }
      return newMapInfo;
    });
  };

  const handleMakerOverlayClose = (id) => {
    setMapInfo((prev) => {
      const index = mapInfo.findIndex((item) => item.id === id);
      const newMapInfo = [...prev];

      if (index != -1) {
        newMapInfo[index].show = false;
      }
      return newMapInfo;
    });
  };

  const renderMapMarkers = () => mapInfo.map((location) => (
    <Box
      key={location.id}
      lat={location.latitude}
      lng={location.longitude}
      sx={{ cursor: 'pointer' }}>
      <img src="/imgs/map-pin.svg" alt="Eagle rider pin" />
      <FloatingLocationInfoV2
        content={content}
        name={location.name}
        address={`${location.street_address}, ${
          location.city ? `${location.city}, ` : ''
        } ${location.state} ${location.postal_code}, ${
          location.country_name
        }`}
        phones={[location.phone]}
        operationHours={location.hours_of_operation}
        open={location.show}
        locationSlug={location.url}
        handleClose={() => handleMakerOverlayClose(location.id)}
        handleBook={() => handleBookNowClick(location)}
        isClubMember={location.participating_in_membership}
        />
    </Box>
  ));

  return (
    <StyledBox className={className}>
      <Map
        defaultCenter={mapCenter}
        mapCenter={
          isLargeScreen ? mapCenter.large_screen : mapCenter.small_screen
        }
        defaultZoom={isLargeScreen ? 5 : 3.5}
        mapZoom={
          isLargeScreen
            ? mapCenter.large_screen.zoom
            : mapCenter.small_screen.zoom
        }
        mapLocations={mapInfo}
        handleMarkerClick={handleMarkerClick}
        renderMapMarkers={renderMapMarkers}
        darkMode
        gestureHandlingValue="cooperative"
      />
    </StyledBox>
  );
};

export { LocationsMapWrapperV2 };
